
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5(40|62|90)|131|60|665|80|871)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
